export const routes = [
  {
    path: '/login',
    name: 'login',
    display: 'Login',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    display: 'Home',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/available-forms',
    name: 'available-forms',
    display: 'Available Forms',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "available-forms" */ '../views/AvailableForms.vue')
  },
  {
    path: '/test-elements',
    name: 'test-elements',
    display: 'Test Elements',
    component: () => import(/* webpackChunkName: "test-elements" */ '../views/TestElements.vue'),
    props: true
  },
  {
    path: '/entry-screening',
    name: 'entry-screening',
    display: 'Entry Screening',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "entry-screening" */ '../views/EntryScreening.vue'),
    props: true
  },
  {
    path: '/exit-screening',
    name: 'exit-screening',
    display: 'Exit Screening',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "exit-screening" */ '../views/ExitScreening.vue'),
    props: true
  },
  {
    path: '/exit-screening-ohio',
    name: 'exit-screening-ohio',
    display: 'Exit Screening',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "exit-screening-ohio" */ '../views/ExitScreeningOhio.vue'),
    props: true
  },
  {
    path: '/mid-shift-screening',
    name: 'mid-shift-screening',
    display: 'Mid Shift Screening',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "mid-shift-screening" */ '../views/MidShiftScreening.vue'),
    props: true
  },
  {
    path: '/first-time-visitor',
    name: 'first-time-visitor',
    display: 'First Time Visitor',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "first-time-visitor" */ '../views/FirstTimeVisitor.vue')
  },
  {
    path: '/health-check',
    name: 'health-check',
    display: 'HealthCheck',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "health-check" */ '../views/HealthCheck.vue'),
    props: true
  },
  {
    path: '/diagnostics',
    name: 'diagnostics',
    display: 'Diagnostics',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "diagnostics" */ '../views/Diagnostics.vue'),
    props: true
  },
  {
    path: '/diagnostics/view/:id',
    name: 'diagnostics-view',
    display: 'View Diagnostic',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "diagnostics-view" */ '../views/DiagnosticsView.vue'),
    props: true
  },
  {
    path: '/covid-19-test',
    name: 'covid-19-test',
    display: 'COVID-19 Test',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "covid-19-test" */ '../views/Covid19Test.vue'),
    meta: { authorization: { permission: 'perform', resource: 'CovidTests' } },
    props: true
  },
  {
    path: '/resident',
    name: 'resident',
    display: 'Resident',
    component: () => import(/* webpackChunkName: "questionnaire" */ '../views/Questionnaire.vue'),
    props: true
  },
  {
    path: '/vaccine-tracking',
    name: 'vaccine-tracking',
    display: 'Vaccine Tracking',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "vaccine-tracking" */ '../views/VaccineTracking.vue'),
    props: true
  },
  {
    path: '/test-tracking',
    name: 'test-tracking',
    display: 'Test Tracking',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "vaccine-tracking" */ '../views/TestTracking.vue'),
    props: true
  },
  {
    path: '/visitor-guidelines',
    name: 'visitor-guidelines',
    display: 'Visitor Guidelines',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "first-time-visitor" */ '../views/VisitationGuidelines.vue')
  },
  {
    path: '/set-visitor-type',
    name: 'set-visitor-type',
    display: 'Set Visitor type',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "first-time-visitor" */ '../views/SetVisitorType.vue')
  },
  {
    path: '/immunization-tracking',
    name: 'immunization-tracking',
    display: 'Immunization Tracking',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "vaccine-tracking" */ '../views/ImmunizationTracking.vue'),
    props: true
  }
]
